import each from "lodash/each";

class StepNav {
  scope: Element = null;
  private navItems: NodeList = null;
  private sectionItems: NodeList = null;
  groupTitle: string = null;

  private nextStep: number = null;
  currentStep: number = 0;

  constructor(sectionItems: NodeList = null, startAt: number = 0) {
    let isManuallyControlled: boolean = false;
    this.scope = document.querySelector(".step-nav-wrapper");

    if (!this.scope) {
      return;
    }
    
    this.groupTitle = this.scope.getAttribute("data-step-title");
    this.navItems = this.scope.querySelectorAll("li");
    this.sectionItems = sectionItems || document.querySelectorAll(".stepNavSection");

    each(
      document.querySelectorAll(".stepNavChange"),
      (btn: Element): void => {
        btn.addEventListener(
          "click",
          (e: Event): void => {
            e.preventDefault();
            this.changeStep(parseInt(btn.getAttribute("data-step")));
          }
        );
      }
    );

    each(this.navItems, item => {
      if (item.className.indexOf("is-completed") !== -1) {
        isManuallyControlled = true;
      }
    });

    if (!isManuallyControlled) {
      this.changeStep(startAt);
    }
    
    window['pushDigitalData']({
      "event": "_formNavigate",
      "form": {
          "name": this.groupTitle,
          "stage": (this.scope.querySelector("li.is-active span")).textContent
      },
    }, true);
  }

  private updateNav(): void {
    const { navItems } = this;

    if (this.nextStep >= navItems.length) {
      console.log("Step number is beyond range of navItems");
      return;
    }

    each(
      navItems,
      (navItem: Element, index: number): void => {
        navItem.classList.remove("is-active");
        navItem.classList.remove("is-completed");

        if (index === this.nextStep) {
          navItem.classList.add("is-active");
        } else if (index < this.nextStep) {
          navItem.classList.add("is-completed");
        }
      }
    );
  }

  private updateSections(): void {
    const { sectionItems } = this;

    if (this.nextStep >= sectionItems.length) {
      console.log("Step number is beyond range of sectionItems");
      return;
    }

    each(
      sectionItems,
      (sectionItem: Element, index: number): void => {
        sectionItem.classList.remove("is-active");
        sectionItem.classList.remove("is-completed");

        if (index === this.nextStep) {
          sectionItem.classList.add("is-active");
        } else if (index < this.nextStep) {
          sectionItem.classList.add("is-completed");
        }
      }
    );
  }

  navigate(direction: -1 | 1 = 1): number {
    return this.changeStep(direction === 1 ? this.currentStep + 1 : this.currentStep - 1);
  }

  changeStep(newStep: number = 0): number {
    this.beforeChange(newStep);
    this.nextStep = newStep;

    window.scrollTo(0, 0);

    if (this.sectionItems && this.sectionItems.length) {
      this.updateSections();
    }

    if (this.navItems && this.navItems.length) {
      this.updateNav();
    }

    this.currentStep = this.nextStep;
    this.onChangeComplete(this.currentStep);

    return this.currentStep;
  }

  beforeChange(step: number) {}
  onChangeComplete(step: number) {}
}

export default StepNav;
